import { render, staticRenderFns } from "./SpoiledAreaFilter.vue?vue&type=template&id=3c8c267a&scoped=true&"
import script from "./SpoiledAreaFilter.vue?vue&type=script&lang=js&"
export * from "./SpoiledAreaFilter.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledAreaFilter.vue?vue&type=style&index=0&id=3c8c267a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c267a",
  null
  
)

export default component.exports